import { Button, Dialog } from "@hellocarbo/lasagne";
import { use } from "react";
import { useTranslation } from "react-i18next";

import { PortalContainerContext } from "@/contexts";

type ConfirmIntegrationtModalProps = {
  handleIntegration?: () => Promise<void>;
};

const ConfirmIntegrationtModal = ({
  handleIntegration,
}: ConfirmIntegrationtModalProps) => {
  const { container } = use(PortalContainerContext);
  const { t } = useTranslation("importDeposit");

  return (
    <Dialog
      trigger={
        <Button intent="primary" size="small">
          {t("importDeposit:integrationModal.triggerButton")}
        </Button>
      }
      title={t("importDeposit:integrationModal.title")}
      description={t("importDeposit:integrationModal.content")}
      warningMessage={t("importDeposit:integrationModal.warning")}
      portalContainer={container as Element}
      primaryAction={{
        buttonText: t("importDeposit:integrationModal.integrationCta"),
        onClick: handleIntegration, // eslint-disable-line @typescript-eslint/no-misused-promises
      }}
      secondaryAction={{
        buttonText: t("importDeposit:integrationModal.secondaryCta"),
      }}
    />
  );
};

export default ConfirmIntegrationtModal;
